import { render } from "./IconUsers.vue?vue&type=template&id=402e70a8"
import script from "./IconUsers.vue?vue&type=script&lang=js"
export * from "./IconUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__